module.exports = __webpack_public_path__ + "static/img/shiming.df2290d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/shiming.png
// module id = qkME
// module chunks = 1